import React, { useState, useEffect, useCallback } from "react";
import "./Hero.css";

const slides = [
  {
    id: 1,
    image: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=1600&q=80&fit=crop",
    title: "Top 50 Online Business Ideas",
    cta: "GET E-BOOK NOW",
    ctaHref: "/buy",
  },
  {
    id: 2,
    image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=1600&q=80&fit=crop",
    title: "Start Your Online Business Today",
    cta: "EXPLORE IDEAS",
    ctaHref: "/buy",
  },
  {
    id: 3,
    image: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=1600&q=80&fit=crop",
    title: "Proven Business Models",
    cta: "LEARN MORE",
    ctaHref: "/buy",
  },
  {
    id: 4,
    image: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=1600&q=80&fit=crop",
    title: "India Edition",
    cta: "GET STARTED",
    ctaHref: "/buy",
  },
  {
    id: 5,
    image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=1600&q=80&fit=crop",
    title: "Everything You Need to Know",
    cta: "BUY NOW",
    ctaHref: "/buy",
  },
  {
    id: 6,
    image: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=1600&q=80&fit=crop",
    title: "Limited Time Offer - Save 30%",
    cta: "GRAB DEAL",
    ctaHref: "/buy",
  },
];

const Hero = ({ sectionNumber = "01" }) => {
  const [current, setCurrent] = useState(0);
  const [transitioning, setTransitioning] = useState(false);

  const goTo = useCallback((idx) => {
    if (transitioning) return;
    setTransitioning(true);
    setCurrent(idx);
    setTimeout(() => setTransitioning(false), 600);
  }, [transitioning]);

  const prev = () => goTo((current - 1 + slides.length) % slides.length);
  const next = useCallback(() => goTo((current + 1) % slides.length), [current, goTo]);

  useEffect(() => {
    const timer = setInterval(next, 4500);
    return () => clearInterval(timer);
  }, [next]);

  return (
    <>
      <section className="hero-section" title={sectionNumber}>
        <div className="hero-carousel">
        {/* Slides */}
        {slides.map((slide, i) => (
          <div
            key={slide.id}
            className={`hero-slide${i === current ? " hero-slide--active" : ""}`}
            aria-hidden={i !== current}
          >
            <img
              src={slide.image}
              alt={slide.title}
              className="hero-slide-img"
              draggable="false"
            />
            {/* Text overlay */}
            <div className="hero-overlay">
              <h1 className="hero-overlay-title">{slide.title}</h1>
              <a href={slide.ctaHref} className="hero-overlay-cta">{slide.cta}</a>
            </div>
          </div>
        ))}

        {/* Prev / Next arrows */}
        <button
          className="hero-arrow hero-arrow--prev"
          onClick={prev}
          aria-label="Previous slide"
        >
          &#8249;
        </button>
        <button
          className="hero-arrow hero-arrow--next"
          onClick={next}
          aria-label="Next slide"
        >
          &#8250;
        </button>


        </div>
      </section>

      {/* Dot indicators on global background */}
      <div className="hero-dots" role="tablist" aria-label="Slide indicators">
        {slides.map((_, i) => (
          <button
            key={i}
            role="tab"
            aria-selected={i === current}
            className={`hero-dot${i === current ? " hero-dot--active" : ""}`}
            onClick={() => goTo(i)}
            aria-label={`Go to slide ${i + 1}`}
          />
        ))}
      </div>
    </>
  );
};

export default Hero;
